import { forwardRef } from 'react';

import type { TextFieldModel } from '../../../types';
import Box from '../../Button/Box';
import Icon from '../../Icon';
import BaseStyleTextField from '../BaseStyleTextField';

import s from './WithButtonTextField.module.scss';

export interface WithButtonTextFieldProps extends TextFieldModel {
  buttonLabel: string;
  onClick: () => void;
  isButtonDisabled?: boolean;
}

const WithButtonTextField = forwardRef<HTMLInputElement, WithButtonTextFieldProps>(
  ({ success, buttonLabel, onClick, isButtonDisabled = false, ...props }, ref) => {
    return (
      <BaseStyleTextField {...props} ref={ref}>
        {success ? (
          <Icon className={s.icon} type="check-mark" color="green.600" size={24} />
        ) : (
          <Box size="small" state="primary" disabled={isButtonDisabled} onClick={onClick}>
            {buttonLabel}
          </Box>
        )}
      </BaseStyleTextField>
    );
  }
);

export default WithButtonTextField;
